<template>
    <div>
        <div class="block md:hidden p-4 space-y-4">
            <div class="font-medium ml-2 text-2xl">{{ $tt('批量处理') }}</div>
            <section class="batch-action-mobile-panel" aria-label="批量处理功能栏">
                <div class="batch-action-mobile-grid">
                    <button v-for="action in quickActions.filter(item => item.key !== 'more' && item.key !== 'close')"
                        :key="`mobile-${action.key}`" type="button" class="batch-action-mobile-item"
                        :disabled="isLoading || !checkedData.length" @click="handleQuickAction(action)">
                        <span class="batch-action-mobile-item__icon">
                            <svg-icon v-if="!isInlineIcon(action.icon)" :name="action.icon" />
                            <span v-else aria-hidden="true">＋</span>
                        </span>
                        <span class="batch-action-mobile-item__text">
                            <strong>{{ $tt(action.label) }}</strong>
                            <small>{{ $tt(action.description) }}</small>
                        </span>
                    </button>
                </div>
                <button type="button" class="batch-action-mobile-more" :disabled="isLoading || !checkedData.length"
                    @click="toggleMoreActions()">
                    {{ $tt('更多操作') }} · {{ checkedData.length }}
                    <span aria-hidden="true">→</span>
                </button>
            </section>
        </div>

        <div class="hidden md:flex batch-action-nav" aria-label="批量处理功能栏">
            <div class="batch-action-nav__items">
                <button v-for="action in quickActions" :key="action.key"
                    class="batch-action-nav__item tooltip tooltip-top" type="button"
                    :class="{ 'is-primary': action.key === 'more' }" :data-tip="$tt(action.label)"
                    :title="$tt(action.label)" :aria-label="$tt(action.label)" :disabled="isLoading"
                    @click="handleQuickAction(action)">
                    <svg-icon v-if="!isInlineIcon(action.icon)" :name="action.icon" class="batch-action-nav__icon" />
                    <svg v-else-if="action.icon === 'manual-edit'" viewBox="0 0 15 15" fill="none"
                        class="batch-action-nav__icon">
                        <path d="M12.9697 0.969727L4.96973 8.96973L6.03039 10.0304L14.0304 2.03039L12.9697 0.969727Z"
                            fill="currentColor" />
                        <path
                            d="M2.5 1.25006C1.25736 1.25006 0.25 2.25742 0.25 3.50006V12.5001C0.25 13.7427 1.25736 14.7501 2.5 14.7501H11.5C12.7426 14.7501 13.75 13.7427 13.75 12.5001V7.00006H12.25V12.5001C12.25 12.9143 11.9142 13.2501 11.5 13.2501H2.5C2.08579 13.2501 1.75 12.9143 1.75 12.5001V3.50006C1.75 3.08585 2.08579 2.75006 2.5 2.75006H8V1.25006H2.5Z"
                            fill="currentColor" />
                    </svg>
                    <svg v-else-if="action.icon === 'auto-scrape'" viewBox="0 0 1036 1024" fill="none"
                        class="batch-action-nav__icon">
                        <path
                            d="M938.74776 69.162438L893.455144 52.837457a67.26383 67.26383 0 1 0-20.007307 64.317969l42.469499 15.465771c28.722146 10.433258 53.516478 49.097686 53.516478 83.466066v598.869028c0 34.000148-24.548843 72.664576-53.639223 82.729601l-38.296195 13.501863a67.26383 67.26383 0 1 0 14.115585 66.650109l46.397313-16.447724c55.60313-19.51633 98.195372-83.711555 98.195373-146.311105V216.210008c0-62.354061-42.960475-126.917519-98.195373-147.293059zM222.16703 888.971053a66.895597 66.895597 0 0 0-52.166292 24.548843L121.516773 897.440403A89.1123 89.1123 0 0 1 67.26383 822.443688V208.722611a89.97151 89.97151 0 0 1 54.252943-76.101414l51.920803-18.657121a67.632063 67.632063 0 1 0-15.465771-65.913643L98.195372 69.285182A157.358084 157.358084 0 0 0 0 208.722611v613.721077a156.253386 156.253386 0 0 0 99.30007 138.332731L159.56748 982.011168a67.509318 67.509318 0 1 0 62.59955-93.040115z"
                            fill="currentColor" />
                        <path
                            d="M426.29066 572.413721l86.780161-205.105584 91.935417 205.105584z m282.311696 230.759125h119.798354l-267.58239-592.854561-98.195372 1.104698-251.625642 592.118096 118.079936-1.350187L380.507068 680.183142h272.492158l55.112153 122.744215z"
                            fill="currentColor" />
                    </svg>
                    <svg v-else-if="action.icon === 'tidy-folder'" viewBox="0 0 1024 1024" fill="none"
                        class="batch-action-nav__icon">
                        <path
                            d="M512 133.034667L180.736 298.666667 512 464.298667 843.264 298.666667 512 133.034667z m19.072-85.845334l426.666667 213.333334a42.666667 42.666667 0 0 1 0 76.330666l-426.666667 213.333334a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333334a42.666667 42.666667 0 0 1 0-76.330666l426.666667-213.333334a42.581333 42.581333 0 0 1 38.144 0z m388.522667 426.666667a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 677.632l407.594667-203.776z m0 213.333333a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 890.965333l407.594667-203.776z"
                            fill="currentColor" />
                    </svg>
                    <svg v-else-if="action.icon === 'delete-folder'" viewBox="0 0 14 14" fill="none"
                        class="batch-action-nav__icon">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9 0H5V1.5L9 1.5V0ZM0 2.5H14V4H12.75V11.75C12.75 12.9927 11.7426 14 10.5 14L3.65821 14C2.41556 14 1.4082 12.9927 1.4082 11.75V4H0V2.5ZM2.9082 4H11.25V11.75C11.25 12.1642 10.9142 12.5 10.5 12.5L3.6582 12.5C3.24399 12.5 2.9082 12.1642 2.9082 11.75V4ZM6.25 5.75V10.75H4.75V5.75H6.25ZM9.25 10.75V5.75H7.75V10.75H9.25Z"
                            fill="currentColor" />
                    </svg>
                    <svg v-else-if="action.icon === 'split-cue'" viewBox="0 0 16 14" fill="none"
                        class="batch-action-nav__icon">
                        <path
                            d="M6.00001 0.750244C6.00001 0.33603 5.66422 0.000244141 5.25001 0.000244141C4.83579 0.000244141 4.50001 0.336031 4.50001 0.750244L4.50001 1.10975C4.50001 1.72344 4.75068 2.31051 5.19395 2.73492L7.26701 4.71982L4.82988 7.09988C4.42039 7.49039 4.31633 8.10894 4.59285 8.61168L4.60292 8.63001L6.88601 12.2829C6.96051 12.4021 7.00001 12.5399 7.00001 12.6804V13.2502C7.00001 13.6645 7.33579 14.0002 7.75001 14.0002C8.16422 14.0002 8.50001 13.6645 8.50001 13.2502L8.50001 12.6804C8.50001 12.2587 8.3815 11.8455 8.158 11.4879L6.00724 8.04672L8.47876 5.63307C8.8733 5.28191 8.97223 4.73973 8.81074 4.29147C8.7162 4.02904 8.53253 3.85435 8.46556 3.79066L8.45717 3.78266L6.23132 1.65147C6.08357 1.51 6.00001 1.31431 6.00001 1.10975L6.00001 0.750244Z"
                            fill="currentColor" />
                        <path
                            d="M2.5 1.75024C2.08421 1.75024 1.75 2.08446 1.75 2.50024V11.5002C1.75 11.916 2.08421 12.2502 2.5 12.2502H5.25C5.66421 12.2502 6 12.586 6 13.0002C6 13.4145 5.66421 13.7502 5.25 13.7502H2.5C1.25579 13.7502 0.25 12.7445 0.25 11.5002V2.50024C0.25 1.25603 1.25579 0.250244 2.5 0.250244H3.11C3.52421 0.250244 3.86 0.586031 3.86 1.00024C3.86 1.41446 3.52421 1.75024 3.11 1.75024H2.5Z"
                            fill="currentColor" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.47296 2.23137C7.87783 1.41306 8.4474 0.250244 9.47952 0.250244H13.4995C14.7437 0.250244 15.7495 1.25603 15.7495 2.50024V11.5002C15.7495 12.7445 14.7437 13.7502 13.4995 13.7502H11.1795C10.7359 13.7502 10.302 13.5087 10.0856 13.0893L7.90236 9.06168L7.90098 9.05917C7.63468 8.57234 7.71835 7.95284 8.13705 7.5617L10.6534 4.96992L8.48264 2.24467L8.47296 2.23137ZM10.0065 1.75024L11.9884 4.23833L11.9998 4.25432C12.3627 4.7623 12.2997 5.45211 11.8588 5.88178L9.30861 8.50837L11.337 12.2502H13.4995C13.9153 12.2502 14.2495 11.916 14.2495 11.5002V2.50024C14.2495 2.08446 13.9153 1.75024 13.4995 1.75024H10.0065Z"
                            fill="currentColor" />
                    </svg>
                    <svg v-else-if="action.icon === 'replace-text'" viewBox="0 0 12 16" fill="none"
                        class="batch-action-nav__icon">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.0001 4.25006V5.75006L0 5.75006V4.93951L3.96979 0.969727L5.03045 2.03039L2.81078 4.25006L12.0001 4.25006ZM0.000116289 11.7501L0.000116348 10.2501L12 10.2501V11.0608L8.03045 15.0304L6.96979 13.9697L9.18946 11.7501H0.000116289Z"
                            fill="currentColor" />
                    </svg>
                    <svg v-else viewBox="0 0 24 24" fill="none" class="batch-action-nav__icon">
                        <path d="M12 5.5a1.5 1.5 0 1 0 0 .01M12 12a1.5 1.5 0 1 0 0 .01M12 18.5a1.5 1.5 0 1 0 0 .01"
                            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
        <div v-if="moreActionsOpen" class="batch-action-more" role="dialog" :aria-label="$tt('更多操作')">
            <div class="batch-action-more__header">
                <div>
                    <p>{{ $tt('更多操作') }}</p>
                    <span>{{ $tt('批量工具的其余功能与快捷指令。') }}</span>
                </div>
                <button class="batch-action-more__close" type="button" :title="$tt('关闭更多操作')"
                    :aria-label="$tt('关闭更多操作')" @click="toggleMoreActions(false)">
                    <svg-icon name="x" />
                </button>
            </div>
            <div v-if="isV2" class="batch-action-more__tabs segmented-tabs" role="tablist" :aria-label="$tt('更多操作分类')">
                <button :class="['segmented-tab is-compact', moreActionTab === 'operations' ? 'is-active' : '']"
                    type="button" role="tab" :aria-selected="moreActionTab === 'operations'"
                    @click="switchMoreActionTab('operations')">
                    {{ $tt('原子操作') }}
                </button>
                <button :class="['segmented-tab is-compact', moreActionTab === 'presets' ? 'is-active' : '']"
                    type="button" role="tab" :aria-selected="moreActionTab === 'presets'"
                    @click="switchMoreActionTab('presets')">
                    {{ $tt('快捷指令') }}
                </button>
            </div>
            <div v-if="!isV2 || moreActionTab === 'operations'" class="batch-action-more__grid">
                <button v-for="action in availableMoreActions" :key="action.key" class="batch-action-more__item"
                    type="button" @click="openAction(action)">
                    <span class="batch-action-more__icon">
                        <svg-icon v-if="!isInlineIcon(action.icon)" :name="action.icon" />
                        <svg v-else :viewBox="inlineIconViewBox(action.icon)" fill="none" class="batch-action-more__svg-icon"
                            v-html="inlineIconMarkup(action.icon)"></svg>
                    </span>
                    <span><strong>{{ $tt(action.label) }}</strong><small>{{ $tt(action.description) }}</small></span>
                </button>
            </div>
            <div v-if="isV2 && moreActionTab === 'presets'" class="batch-action-more__presets">
                <div v-if="loadingPresets" class="batch-action-more__empty">
                    {{ $tt('正在加载...') }}
                </div>
                <div v-else-if="!activePresets.length" class="batch-action-more__empty">
                    {{ $tt('暂无可用快捷指令') }}
                </div>
                <div v-else class="batch-action-more__grid batch-action-more__grid--presets">
                    <button v-for="preset in activePresets" :key="preset.id" class="batch-action-more__item"
                        type="button" :disabled="isLoading || executingPresetId === preset.id"
                        @click="executePresetDirect(preset)">
                        <span class="batch-action-more__icon"><svg-icon name="sys-backend" /></span>
                        <span>
                            <strong>{{ preset.display_name }}</strong>
                            <small>{{ preset.description }}</small>
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="batch-action-drawers" aria-hidden="true">
            <BatchSettings ref="batchSettings" :detail="detail" :is-loading="isLoading" :show-trigger="false"
                @loading-start="handleLoadingStart" @loading-end="handleLoadingEnd" />
            <BatchOperationRunner ref="batchOperationRunner" :detail="detail" :is-loading="isLoading"
                :checked-data="checkedData" :file-path="filePath" :show-trigger="false"
                @loading-start="handleLoadingStart" @loading-end="handleLoadingEnd" />
            <OperationPresetRunner ref="operationPresetRunner" :detail="detail" :is-loading="isLoading"
                :checked-data="checkedData" :file-path="filePath" :user-role="getUserRole" :show-trigger="false"
                @loading-start="handleLoadingStart" @loading-end="handleLoadingEnd" />
        </div>
    </div>
</template>

<script>
import BatchSettings from '@/components/batch/BatchSettings.vue'
import BatchOperationRunner from '@/components/batch/BatchOperationRunner.vue'
import OperationPresetRunner from '@/components/batch/OperationPresetRunner.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import { mapGetters } from 'vuex'

const INLINE_ICON_KEYS = ['manual-edit', 'auto-scrape', 'tidy-folder', 'delete-folder', 'split-cue', 'replace-text', 'more-actions']

const INLINE_ICON_SVGS = {
    'manual-edit': {
        viewBox: '0 0 15 15',
        markup: `<path d="M12.9697 0.969727L4.96973 8.96973L6.03039 10.0304L14.0304 2.03039L12.9697 0.969727Z"
            fill="currentColor" />
        <path
            d="M2.5 1.25006C1.25736 1.25006 0.25 2.25742 0.25 3.50006V12.5001C0.25 13.7427 1.25736 14.7501 2.5 14.7501H11.5C12.7426 14.7501 13.75 13.7427 13.75 12.5001V7.00006H12.25V12.5001C12.25 12.9143 11.9142 13.2501 11.5 13.2501H2.5C2.08579 13.2501 1.75 12.9143 1.75 12.5001V3.50006C1.75 3.08585 2.08579 2.75006 2.5 2.75006H8V1.25006H2.5Z"
            fill="currentColor" />`
    },
    'auto-scrape': {
        viewBox: '0 0 1036 1024',
        markup: `<path
            d="M938.74776 69.162438L893.455144 52.837457a67.26383 67.26383 0 1 0-20.007307 64.317969l42.469499 15.465771c28.722146 10.433258 53.516478 49.097686 53.516478 83.466066v598.869028c0 34.000148-24.548843 72.664576-53.639223 82.729601l-38.296195 13.501863a67.26383 67.26383 0 1 0 14.115585 66.650109l46.397313-16.447724c55.60313-19.51633 98.195372-83.711555 98.195373-146.311105V216.210008c0-62.354061-42.960475-126.917519-98.195373-147.293059zM222.16703 888.971053a66.895597 66.895597 0 0 0-52.166292 24.548843L121.516773 897.440403A89.1123 89.1123 0 0 1 67.26383 822.443688V208.722611a89.97151 89.97151 0 0 1 54.252943-76.101414l51.920803-18.657121a67.632063 67.632063 0 1 0-15.465771-65.913643L98.195372 69.285182A157.358084 157.358084 0 0 0 0 208.722611v613.721077a156.253386 156.253386 0 0 0 99.30007 138.332731L159.56748 982.011168a67.509318 67.509318 0 1 0 62.59955-93.040115z"
            fill="currentColor" />
        <path
            d="M426.29066 572.413721l86.780161-205.105584 91.935417 205.105584z m282.311696 230.759125h119.798354l-267.58239-592.854561-98.195372 1.104698-251.625642 592.118096 118.079936-1.350187L380.507068 680.183142h272.492158l55.112153 122.744215z"
            fill="currentColor" />`
    },
    'tidy-folder': {
        viewBox: '0 0 1024 1024',
        markup: `<path
            d="M512 133.034667L180.736 298.666667 512 464.298667 843.264 298.666667 512 133.034667z m19.072-85.845334l426.666667 213.333334a42.666667 42.666667 0 0 1 0 76.330666l-426.666667 213.333334a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333334a42.666667 42.666667 0 0 1 0-76.330666l426.666667-213.333334a42.581333 42.581333 0 0 1 38.144 0z m388.522667 426.666667a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 677.632l407.594667-203.776z m0 213.333333a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 890.965333l407.594667-203.776z"
            fill="currentColor" />`
    },
    'delete-folder': {
        viewBox: '0 0 14 14',
        markup: `<path fill-rule="evenodd" clip-rule="evenodd"
            d="M9 0H5V1.5L9 1.5V0ZM0 2.5H14V4H12.75V11.75C12.75 12.9927 11.7426 14 10.5 14L3.65821 14C2.41556 14 1.4082 12.9927 1.4082 11.75V4H0V2.5ZM2.9082 4H11.25V11.75C11.25 12.1642 10.9142 12.5 10.5 12.5L3.6582 12.5C3.24399 12.5 2.9082 12.1642 2.9082 11.75V4ZM6.25 5.75V10.75H4.75V5.75H6.25ZM9.25 10.75V5.75H7.75V10.75H9.25Z"
            fill="currentColor" />`
    },
    'split-cue': {
        viewBox: '0 0 16 14',
        markup: `<path
            d="M6.00001 0.750244C6.00001 0.33603 5.66422 0.000244141 5.25001 0.000244141C4.83579 0.000244141 4.50001 0.336031 4.50001 0.750244L4.50001 1.10975C4.50001 1.72344 4.75068 2.31051 5.19395 2.73492L7.26701 4.71982L4.82988 7.09988C4.42039 7.49039 4.31633 8.10894 4.59285 8.61168L4.60292 8.63001L6.88601 12.2829C6.96051 12.4021 7.00001 12.5399 7.00001 12.6804V13.2502C7.00001 13.6645 7.33579 14.0002 7.75001 14.0002C8.16422 14.0002 8.50001 13.6645 8.50001 13.2502L8.50001 12.6804C8.50001 12.2587 8.3815 11.8455 8.158 11.4879L6.00724 8.04672L8.47876 5.63307C8.8733 5.28191 8.97223 4.73973 8.81074 4.29147C8.7162 4.02904 8.53253 3.85435 8.46556 3.79066L8.45717 3.78266L6.23132 1.65147C6.08357 1.51 6.00001 1.31431 6.00001 1.10975L6.00001 0.750244Z"
            fill="currentColor" />
        <path
            d="M2.5 1.75024C2.08421 1.75024 1.75 2.08446 1.75 2.50024V11.5002C1.75 11.916 2.08421 12.2502 2.5 12.2502H5.25C5.66421 12.2502 6 12.586 6 13.0002C6 13.4145 5.66421 13.7502 5.25 13.7502H2.5C1.25579 13.7502 0.25 12.7445 0.25 11.5002V2.50024C0.25 1.25603 1.25579 0.250244 2.5 0.250244H3.11C3.52421 0.250244 3.86 0.586031 3.86 1.00024C3.86 1.41446 3.52421 1.75024 3.11 1.75024H2.5Z"
            fill="currentColor" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.47296 2.23137C7.87783 1.41306 8.4474 0.250244 9.47952 0.250244H13.4995C14.7437 0.250244 15.7495 1.25603 15.7495 2.50024V11.5002C15.7495 12.7445 14.7437 13.7502 13.4995 13.7502H11.1795C10.7359 13.7502 10.302 13.5087 10.0856 13.0893L7.90236 9.06168L7.90098 9.05917C7.63468 8.57234 7.71835 7.95284 8.13705 7.5617L10.6534 4.96992L8.48264 2.24467L8.47296 2.23137ZM10.0065 1.75024L11.9884 4.23833L11.9998 4.25432C12.3627 4.7623 12.2997 5.45211 11.8588 5.88178L9.30861 8.50837L11.337 12.2502H13.4995C13.9153 12.2502 14.2495 11.916 14.2495 11.5002V2.50024C14.2495 2.08446 13.9153 1.75024 13.4995 1.75024H10.0065Z"
            fill="currentColor" />`
    },
    'replace-text': {
        viewBox: '0 0 12 16',
        markup: `<path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.0001 4.25006V5.75006L0 5.75006V4.93951L3.96979 0.969727L5.03045 2.03039L2.81078 4.25006L12.0001 4.25006ZM0.000116289 11.7501L0.000116348 10.2501L12 10.2501V11.0608L8.03045 15.0304L6.96979 13.9697L9.18946 11.7501H0.000116289Z"
            fill="currentColor" />`
    },
    'more-actions': {
        viewBox: '0 0 24 24',
        markup: `<path d="M12 5.5a1.5 1.5 0 1 0 0 .01M12 12a1.5 1.5 0 1 0 0 .01M12 18.5a1.5 1.5 0 1 0 0 .01"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />`
    }
}

const QUICK_ACTIONS = [
    { key: 'update_tags', label: '批量编辑', description: '批量写入或修正音乐标签。', icon: 'manual-edit' },
    { key: 'auto_tag', label: '自动刮削', description: '按规则自动匹配并补全元数据。', icon: 'auto-scrape' },
    { key: 'background_scrape', label: '后台刮削', description: '创建后台任务批量刮削文件。', icon: 'sys-backend' },
    { key: 'tidy_folder', label: '整理文件', description: '按标签规则整理目录结构。', icon: 'tidy-folder' },
    { key: 'remove_null_folder', label: '删除文件夹', description: '清理空目录或无效目录。', icon: 'delete-folder' },
    { key: 'format_music', label: '格式转换', description: '批量转换音乐文件格式。', icon: 'transform' },
    { key: 'split_cue', label: '分割音轨', description: '按 CUE 信息拆分整轨文件。', icon: 'split-cue' },
    { key: 'replace_text', label: '替换文本', description: '批量替换文件名或标签文本。', icon: 'replace-text' },
    { key: 'file_index', label: '文件索引', description: '生成或刷新文件索引信息。', icon: 'file-index' },
    { key: 'import_music', label: '导入收藏', description: '把本地音乐导入收藏库。', icon: 'import-music' },
    { key: 'duplicate_check', label: '重复文件检查', description: '检查重复的音乐文件。', icon: 'duplicate-file' },
    { key: 'convert_chinese', label: '简繁体转换', description: '转换标签中的简繁体文本。', icon: 'transform' },
    { key: 'encoding_fix', label: '乱码修复', description: '修复异常编码的元数据。', icon: 'fix-encoding' },
    { key: 'more', label: '更多操作', description: '查看更多批量工具。', icon: 'more-actions' },
    { key: 'close', label: '关闭批量处理', description: '收起当前批量操作栏。', icon: 'x' }
]

const MORE_ACTIONS = [
    { key: 'update_tags', label: '批量编辑', description: '批量写入或修正音乐标签。', icon: 'manual-edit' },
    { key: 'auto_tag', label: '自动刮削', description: '按规则自动匹配并补全元数据。', icon: 'auto-scrape' },
    { key: 'background_scrape', label: '后台刮削', description: '创建后台任务批量刮削文件。', icon: 'sys-backend' },
    { key: 'tidy_folder', label: '整理文件', description: '按标签规则整理目录结构。', icon: 'tidy-folder' },
    { key: 'remove_null_folder', label: '删除文件夹', description: '清理空目录或无效目录。', icon: 'delete-folder' },
    { key: 'format_music', label: '格式转换', description: '批量转换音乐文件格式。', icon: 'transform' },
    { key: 'split_cue', label: '分割音轨', description: '按 CUE 信息拆分整轨文件。', icon: 'split-cue' },
    { key: 'replace_text', label: '替换文本', description: '批量替换文件名或标签文本。', icon: 'replace-text' },
    { key: 'file_index', label: '文件索引', description: '生成或刷新文件索引信息。', icon: 'file-index' },
    { key: 'import_music', label: '导入收藏', description: '把本地音乐导入收藏库。', icon: 'import-music' },
    { key: 'duplicate_check', label: '重复文件检查', description: '检查重复的音乐文件。', icon: 'duplicate-file' },
    { key: 'convert_chinese', label: '简繁体转换', description: '转换标签中的简繁体文本。', icon: 'transform' },
    { key: 'encoding_fix', label: '乱码修复', description: '修复异常编码的元数据。', icon: 'fix-encoding' },
    { key: 'split_filename', label: '拆分元数据', description: '从文件名中提取标签信息。', icon: 'document' },
    { key: 'replay_gain', label: '回放增益', description: '批量计算回放增益。', icon: 'gain' },
    { key: 'generate_strm', label: '生成 STRM 文件', description: '生成流媒体索引文件。', icon: 'cloud-down' }
]

export default {
    name: 'batchAction',
    components: { BatchSettings, BatchOperationRunner, OperationPresetRunner, SvgIcon },
    data() {
        return {
            detail: false,
            isLoading: false,
            quickActions: QUICK_ACTIONS,
            moreActions: MORE_ACTIONS,
            moreActionsOpen: false,
            moreActionTab: 'operations',
            presets: [],
            loadingPresets: false,
            executingPresetId: ''
        }
    },
    computed: {
        ...mapGetters(['geFullPath', 'getUserRole']),
        filePath() { return this.geFullPath },
        checkedData() { return this.$store.state.common.checkedData },
        isV2() {
            return String(this.getUserRole || '').toUpperCase() === 'V2'
        },
        availableMoreActions() {
            return this.moreActions
        },
        activePresets() {
            return this.presets.filter(item => item.status === 'active')
        }
    },
    mounted() {
        const savedDetail = window.localStorage.getItem('detail')
        if (savedDetail) this.detail = savedDetail === 'true'
        this.$emit('detail-change', false)
    },
    methods: {
        isInlineIcon(icon) { return INLINE_ICON_KEYS.includes(icon) },
        inlineIconViewBox(icon) {
            return INLINE_ICON_SVGS[icon]?.viewBox || '0 0 24 24'
        },
        inlineIconMarkup(icon) {
            return INLINE_ICON_SVGS[icon]?.markup || INLINE_ICON_SVGS['more-actions'].markup
        },
        openSettingsDrawer() { this.$refs.batchSettings && this.$refs.batchSettings.openSettingsDrawer() },
        handleQuickAction(action) {
            if (action.key === 'more') {
                this.toggleMoreActions()
                return
            }
            if (action.key === 'close') {
                this.toggleMoreActions(false)
                this.$emit('close')
                return
            }
            this.openAction(action)
        },
        openAction(action) {
            this.toggleMoreActions(false)
            if (action.key === 'settings') {
                this.openSettingsDrawer()
                return
            }
            this.$refs.batchOperationRunner.openOperationDrawer(action.key)
        },
        toggleMoreActions(forceValue) {
            this.moreActionsOpen = typeof forceValue === 'boolean' ? forceValue : !this.moreActionsOpen
            if (!this.moreActionsOpen) {
                this.moreActionTab = 'operations'
            }
            if (this.moreActionsOpen && this.isV2 && this.moreActionTab === 'presets') {
                this.loadPresets()
            }
        },
        switchMoreActionTab(tab) {
            this.moreActionTab = tab
            if (tab === 'presets') {
                this.loadPresets()
            }
        },
        async loadPresets() {
            if (this.loadingPresets || this.presets.length) {
                return
            }
            this.loadingPresets = true
            try {
                const response = await this.$api.scriptMgmt.getOperationPresets({ page_size: 100 })
                this.presets = response.data.items || response.data || []
            } catch (error) {
                this.notify('获取快捷指令失败', error.message, 'error')
            } finally {
                this.loadingPresets = false
            }
        },
        buildRuntimeParams(preset) {
            const params = {}
            const schema = preset.input_schema || []
            schema.forEach(field => {
                if (field.type === 'boolean') {
                    params[field.key] = field.default === true || field.default === 'true' || field.default === 1 || field.default === '1'
                } else if (field.type === 'number') {
                    params[field.key] = field.default !== undefined && field.default !== null && field.default !== ''
                        ? Number(field.default)
                        : ''
                } else if (field.type === 'select' && Array.isArray(field.options) && field.options.length) {
                    params[field.key] = field.default !== undefined && field.default !== null && field.default !== ''
                        ? field.default
                        : field.options[0]
                } else {
                    params[field.key] = field.default !== undefined && field.default !== null
                        ? field.default
                        : ''
                }
            })
            return params
        },
        hasMissingRuntimeParams(preset, runtimeParams) {
            return (preset.input_schema || []).some(field => {
                if (!field.required) return false
                const value = runtimeParams[field.key]
                return value === undefined || value === null || value === ''
            })
        },
        riskLabel(level) {
            return { low: '低风险', medium: '中风险', high: '高风险' }[level] || level
        },
        async executePresetDirect(preset) {
            if (!Array.isArray(this.checkedData) || !this.checkedData.length) {
                this.notify('发生提示', '请先勾选文件或文件夹！', 'warning')
                return
            }
            const runtimeParams = this.buildRuntimeParams(preset)
            if (this.hasMissingRuntimeParams(preset, runtimeParams)) {
                this.toggleMoreActions(false)
                this.$refs.operationPresetRunner && this.$refs.operationPresetRunner.openPresetDrawer(preset)
                return
            }
            this.executingPresetId = preset.id
            this.isLoading = true
            this.$emit('loading-start')
            try { 
                const response = await this.$api.scriptMgmt.executeOperationPreset(preset.id, {
                    file_full_path: this.filePath,
                    select_data: this.checkedData,
                    runtime_params: runtimeParams,
                    confirmed: true,
                    risk_acknowledged: ['medium', 'high'].includes(preset.risk_level)
                })
                if (!response.result) throw new Error(response.message || '执行失败')
                this.notify('快捷指令任务已创建', '', 'success')
                this.toggleMoreActions(false)
            } catch (error) {
                this.notify('执行失败', error.message, 'error')
            } finally {
                this.executingPresetId = ''
                this.isLoading = false
                this.$emit('loading-end')
            }
        },
        notify(title, content, type) {
            this.$myMsg.notify({ title: this.$tt(title), content, type, time: 3000 })
        },
        handleLoadingStart() { this.isLoading = true },
        handleLoadingEnd() { this.isLoading = false }
    }
}
</script>

<style scoped>
.batch-action-nav {
    width: 100%;
    min-width: 0;
    overflow: visible;
    scrollbar-width: thin;
}

.batch-action-mobile-panel {
    padding: 0 0.25rem;
}

.batch-action-mobile-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.6rem;
}

.batch-action-mobile-item {
    min-height: 4.9rem;
    display: flex;
    align-items: flex-start;
    gap: 0.65rem;
    padding: 0.75rem;
    border: 1px solid oklch(var(--b3) / 0.65);
    border-radius: 0.95rem;
    background: oklch(var(--b1) / 0.72);
    color: oklch(var(--bc));
    text-align: left;
}

.batch-action-mobile-item:active { transform: scale(0.98); }
.batch-action-mobile-item:disabled { opacity: 0.48; }
.batch-action-mobile-item__icon {
    width: 1.8rem;
    height: 1.8rem;
    flex: 0 0 1.8rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.6rem;
    background: oklch(var(--p) / 0.12);
    color: oklch(var(--p));
    font-size: 0.95rem;
}
.batch-action-mobile-item__icon svg { width: 1.1rem; height: 1.1rem; }
.batch-action-mobile-item__text { min-width: 0; }
.batch-action-mobile-item__text strong,
.batch-action-mobile-item__text small { display: block; }
.batch-action-mobile-item__text strong { font-size: 0.86rem; line-height: 1.25; }
.batch-action-mobile-item__text small { margin-top: 0.25rem; color: oklch(var(--bc) / 0.55); font-size: 0.68rem; line-height: 1.35; }
.batch-action-mobile-more {
    width: 100%;
    margin-top: 0.75rem;
    padding: 0.65rem 0.75rem;
    border-radius: 0.8rem;
    background: oklch(var(--b2) / 0.58);
    color: oklch(var(--bc) / 0.72);
    font-size: 0.82rem;
}
.batch-action-mobile-more:disabled { opacity: 0.48; }

@media (max-width: 380px) {
    .batch-action-mobile-grid { grid-template-columns: 1fr; }
}

.batch-action-drawers {
    position: absolute;
    width: 0;
    height: 0;
    overflow: visible;
}

.batch-action-drawers>div {
    position: absolute;
    width: 0;
    height: 0;
}

.batch-action-nav__items {
    display: flex;
    min-width: max-content;
    align-items: center;
    gap: 8px;
    overflow: visible;
    padding: 2px;
}

.batch-action-nav__item {
    position: relative;
    display: inline-flex;
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    border: 1px solid oklch(var(--bc) / .14);
    border-radius: 12px;
    color: oklch(var(--bc) / .72);
    background: oklch(var(--b1));
    cursor: pointer;
    transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease, transform 160ms ease;
}

.batch-action-nav__item.tooltip::before,
.batch-action-nav__item.tooltip::after {
    z-index: 120;
}

.batch-action-nav__item:hover:not(:disabled),
.batch-action-nav__item:focus-visible {
    z-index: 100;
    border-color: oklch(var(--p) / .45);
    color: oklch(var(--p));
    background: oklch(var(--p) / .1);
    outline: 0;
}

.batch-action-nav__item.is-primary {
    border-color: oklch(var(--p));
    color: oklch(var(--pc));
    background: oklch(var(--p));
}

.batch-action-nav__item:active:not(:disabled) {
    transform: scale(.95);
}

.batch-action-nav__item:disabled {
    cursor: wait;
    opacity: .5;
}

.batch-action-nav__icon {
    width: 16px;
    height: 16px;
    fill: currentColor;
}

.batch-action-more {
    position: fixed;
    z-index: 90;
    bottom: 80px;
    left: 50%;
    width: min(720px, calc(100vw - 24px));
    max-height: min(70vh, 560px);
    overflow-y: auto;
    border: 1px solid oklch(var(--bc) / .14);
    border-radius: 16px;
    background: oklch(var(--b1) / .98);
    box-shadow: 0 20px 40px oklch(var(--bc) / .2);
    transform: translateX(-50%);
}

.batch-action-more__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-bottom: 1px solid oklch(var(--bc) / .1);
}

.batch-action-more__header p {
    margin: 0;
    color: oklch(var(--bc));
    font-size: 14px;
    font-weight: 700;
}

.batch-action-more__header span {
    display: block;
    margin-top: 3px;
    color: oklch(var(--bc) / .56);
    font-size: 12px;
}

.batch-action-more__close {
    display: inline-flex;
    width: 30px;
    height: 30px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    color: oklch(var(--bc) / .7);
    background: transparent;
    cursor: pointer;
}

.batch-action-more__close:hover {
    color: oklch(var(--p));
    background: oklch(var(--p) / .1);
}

.batch-action-more__close svg {
    width: 14px;
    height: 14px;
    fill: currentColor;
}

.batch-action-more__tabs {
    display: inline-flex;
    margin: 10px 12px 0;
}

.batch-action-more__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    padding: 12px;
}

.batch-action-more__grid--presets {
    padding-top: 8px;
}

.batch-action-more__presets {
    min-height: 82px;
}

.batch-action-more__empty {
    color: oklch(var(--bc) / .55);
    font-size: 11px;
}

.batch-action-more__empty {
    padding: 12px 14px 14px;
}

.batch-action-more__item {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 10px;
    padding: 10px;
    border: 1px solid oklch(var(--bc) / .1);
    border-radius: 10px;
    color: oklch(var(--bc));
    background: oklch(var(--b1));
    text-align: left;
    cursor: pointer;
}

.batch-action-more__item > span {
    min-width: 0;
}

.batch-action-more__item:disabled {
    cursor: wait;
    opacity: .58;
}

.batch-action-more__item:hover:not(:disabled) {
    border-color: oklch(var(--p) / .35);
    background: oklch(var(--p) / .06);
}

.batch-action-more__item strong,
.batch-action-more__item small {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.batch-action-more__item strong {
    font-size: 12px;
}

.batch-action-more__item small {
    margin-top: 3px;
    color: oklch(var(--bc) / .55);
    font-size: 11px;
    line-height: 1.35;
    white-space: nowrap;
}

.batch-action-more__icon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    color: oklch(var(--bc) / .72);
    background: oklch(var(--bc) / .07);
}

.batch-action-more__icon svg {
    width: 14px;
    height: 14px;
}

.batch-action-more__icon svg:not(.batch-action-more__svg-icon) {
    fill: currentColor;
}

.batch-action-more__svg-icon {
    fill: none;
}

@media (max-width: 640px) {
    .batch-action-more__grid {
        grid-template-columns: 1fr;
    }
}
</style>
